import { status } from '../../config.ts'
import { pendingResponse } from './data.ts'
import { wait } from '@/__mocks__/util/async.ts'

export default [
  {
    method: 'POST',
    path: '/payment/report-payment/search',
    reply: async () => {
      await wait()
      return [status.ok, pendingResponse]
    }
  }
]
